export default {
  props: {
    width: {
      type: [
        Number,
        String
      ],
      default: '400px'
    },
    title: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    close () {
      this.$emit('close', false)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/dialog.js